module.exports = require("brace/mode/json");